module.exports = __webpack_public_path__ + "img/logo-header.e72a326f.png";